import { render, staticRenderFns } from "./SetAncientMailsView.vue?vue&type=template&id=aae4f6be&scoped=true"
import script from "./SetAncientMailsView.vue?vue&type=script&lang=js"
export * from "./SetAncientMailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae4f6be",
  null
  
)

export default component.exports